import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

export default function DeleteComfirmation(props) {
    const contactCardText = props.deactivateContcact ? `Are you sure you want to deactivate ${props.contactName}?` : props.contactName ? `Are you sure you want to delete ${props.contactName}?` : null
    return (
        <Modal isOpen={props.isOpen} toggle={props.onToggle}>
            <ModalHeader toggle={props.onToggle}>{props.title}</ModalHeader>
            <ModalBody>
                {props.toDelete ? `${ props.toDelete.title }` : contactCardText}
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={props.onDelete}>Ok</Button>{' '}
                <Button color="secondary" onClick={props.onToggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}